import { call, put, takeEvery } from 'redux-saga/effects';
import adminAPI from '../../api/AdminAPI';
import {
  FETCH_ADMIN_DATA_REQUEST,
  FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST,
  EDIT_ADMIN_REPORT_DATA_REQUEST,
  SAVE_CATEGORY_ADMIN_REQUEST,
  EDIT_CATEGORY_ADMIN_REQUEST,
  DELETE_CATEGORY_ADMIN_REQUEST,
  UPLOAD_USER_GUIDE_REQUEST,
  DOWNLOAD_USER_GUIDE_REQUEST,
  SAVE_GLOBAL_SELECTION_IMPC_REQUEST,
  DELETE_GLOBAL_SELECTION_IMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST,
  DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST,
  SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
  DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
  SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST,
  DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST,
  SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST,
  DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST,
  SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
  DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
} from '../actions/types/AdminDashboardActionTypes';
import {
  fetchAdminReportDataSuccessActionCreator,
  fetchAdminReportDataFailureActionCreator,
  fetchAdminReportCategorySuccessActionCreator,
  fetchAdminReportCategoryFailureActionCreator,
  editAdminReportSuccessActionCreator,
  editAdminReportFailureActionCreator,
  saveCategoryAdminSuccessActionCreator,
  saveCategoryAdminFailureActionCreator,
  editCategoryAdminSuccessActionCreator,
  editCategoryAdminFailureActionCreator,
  deleteCategoryAdminSuccessActionCreator,
  deleteCategoryAdminFailureActionCreator,
  uploadUserGuideSuccessActionCreator,
  uploadUserGuideFailureActionCreator,
  downloadUserGuideSuccessActionCreator,
  downloadUserGuideFailureActionCreator,
  saveGlobalSelectionImpcSuccessActionCreator,
  saveGlobalSelectionImpcFailureActionCreator,
  saveGlobalSelectionOperatorSuccessActionCreator,
  saveGlobalSelectionOperatorFailureActionCreator,
  saveGlobalSelectionUnlocodeSuccessActionCreator,
  saveGlobalSelectionUnlocodeFailureActionCreator,
  saveGlobalSelectionMailboxSuccessActionCreator,
  saveGlobalSelectionMailboxFailureActionCreator,
  saveGlobalSelectionProductSuccessActionCreator,
  saveGlobalSelectionProductFailureActionCreator,
  saveGlobalSelectionMrdImpcSuccessActionCreator,
  saveGlobalSelectionMrdImpcFailureActionCreator,
  deleteGlobalSelectionImpcSuccessActionCreator,
  deleteGlobalSelectionImpcFailureActionCreator,
  deleteGlobalSelectionOperatorSuccessActionCreator,
  deleteGlobalSelectionOperatorFailureActionCreator,
  deleteGlobalSelectionUnlocodeSuccessActionCreator,
  deleteGlobalSelectionUnlocodeFailureActionCreator,
  deleteGlobalSelectionMailboxSuccessActionCreator,
  deleteGlobalSelectionMailboxFailureActionCreator,
  deleteGlobalSelectionProductSuccessActionCreator,
  deleteGlobalSelectionProductFailureActionCreator,
  deleteGlobalSelectionMrdImpcSuccessActionCreator,
  deleteGlobalSelectionMrdImpcFailureActionCreator,
} from '../actions/AdminDashboardActions';
import {
  showErrorNotification,
  showSuccessNotification,
} from '../../../../../core/modules/common/redux/actions/NotificationActions';

function* fetchAdminData() {
  try {
    const userAdminResponse = yield call(adminAPI.getAdminReportData);
    const adminData = userAdminResponse.data;

    yield put(fetchAdminReportDataSuccessActionCreator(adminData));
  } catch (e) {
    yield put(fetchAdminReportDataFailureActionCreator(e));
  }
}

function* fetchAdminReportCategoryData() {
  try {
    const userCategoryResponse = yield call(adminAPI.getAdminReportCategoryData);
    const category = userCategoryResponse.data;

    yield put(fetchAdminReportCategorySuccessActionCreator(category));
  } catch (e) {
    yield put(fetchAdminReportCategoryFailureActionCreator(e));
  }
}

function* editAdminReport(action) {
  try {
    const response = yield call(adminAPI.editAdminReport, action.payload);

    yield put(editAdminReportSuccessActionCreator(response.data));
    yield put(showSuccessNotification('Report edited successfully'));
  } catch (e) {
    yield put(editAdminReportFailureActionCreator(e));
  }
}

function* saveCategory(action) {
  try {
    const response = yield call(adminAPI.saveCategoryAdmin, action.payload);

    yield put(saveCategoryAdminSuccessActionCreator({
      ...action.payload,
      ...((response || {}).data || {}),
    }));
    yield put(showSuccessNotification('Category saved successfully'));
  } catch (e) {
    yield put(saveCategoryAdminFailureActionCreator(e));
    yield put(showErrorNotification('Failed request'));
  }
}

function* editCategory(action) {
  try {
    const response = yield call(adminAPI.editCategoryAdmin, action.payload);

    yield put(editCategoryAdminSuccessActionCreator(response.data));
    yield put(showSuccessNotification('Category edited successfully'));
  } catch (e) {
    yield put(editCategoryAdminFailureActionCreator(e));
    yield put(showErrorNotification('Failed request'));
  }
}

function* deleteCategory(action) {
  try {
    yield call(adminAPI.deleteCategoryAdmin, action.payload);

    yield put(deleteCategoryAdminSuccessActionCreator());
    yield put(showSuccessNotification('Category deleted successfully'));
  } catch (e) {
    yield put(deleteCategoryAdminFailureActionCreator(e));
  }
}

function* uploadUserGuide(action) {
  try {
    yield call(adminAPI.uploadUserGuideAdmin, action.payload);

    yield put(uploadUserGuideSuccessActionCreator());
    yield put(showSuccessNotification('The user guide is updated'));
  } catch (e) {
    yield put(uploadUserGuideFailureActionCreator(e));
  }
}

function* downloadUserGuide() {
  try {
    const downloadResponse = yield call(adminAPI.downloadUserGuideAdmin);
    const category = downloadResponse.data;
    const type = 'content-disposition';
    const filename = downloadResponse.headers[type].split('"')[1];
    yield put(downloadUserGuideSuccessActionCreator(category, filename));
  } catch (e) {
    yield put(downloadUserGuideFailureActionCreator(e));
  }
}

function* saveGlobalSelectionImpc(action) {
  try {
    yield call(adminAPI.putAdminImpcGlobalPreset, action.payload);

    yield put(saveGlobalSelectionImpcSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionImpcFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionImpc(action) {
  try {
    yield call(adminAPI.deleteAdminImpcGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionImpcSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionImpcFailureActionCreator(e));
  }
}

function* saveGlobalSelectionOperator(action) {
  try {
    yield call(adminAPI.putAdminOperatorGlobalPreset, action.payload);

    yield put(saveGlobalSelectionOperatorSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionOperatorFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionOperator(action) {
  try {
    yield call(adminAPI.deleteAdminOperatorGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionOperatorSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionOperatorFailureActionCreator(e));
  }
}

function* saveGlobalSelectionUnlocode(action) {
  try {
    yield call(adminAPI.putAdminUnlocodeGlobalPreset, action.payload);

    yield put(saveGlobalSelectionUnlocodeSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionUnlocodeFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionUnlocode(action) {
  try {
    yield call(adminAPI.deleteAdminUnlocodeGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionUnlocodeSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionUnlocodeFailureActionCreator(e));
  }
}

function* saveGlobalSelectionMailbox(action) {
  try {
    yield call(adminAPI.putAdminOperatorMailboxGlobalPreset, action.payload);

    yield put(saveGlobalSelectionMailboxSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionMailboxFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionMailbox(action) {
  try {
    yield call(adminAPI.deleteAdminOperatorMailboxGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionMailboxSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionMailboxFailureActionCreator(e));
  }
}

function* saveGlobalSelectionProduct(action) {
  try {
    yield call(adminAPI.putAdminProductGlobalPreset, action.payload);

    yield put(saveGlobalSelectionProductSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionProductFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionProduct(action) {
  try {
    yield call(adminAPI.deleteAdminProductGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionProductSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionProductFailureActionCreator(e));
  }
}

function* saveGlobalSelectionMrdImpc(action) {
  try {
    yield call(adminAPI.putAdminMrdImpcGlobalPreset, action.payload);

    yield put(saveGlobalSelectionMrdImpcSuccessActionCreator());
  } catch (e) {
    yield put(saveGlobalSelectionMrdImpcFailureActionCreator(e));
  }
}

function* deleteGlobalSelectionMrdImpc(action) {
  try {
    yield call(adminAPI.deleteAdminMrdImpcGlobalPreset, action.payload);

    yield put(deleteGlobalSelectionMrdImpcSuccessActionCreator());
  } catch (e) {
    yield put(deleteGlobalSelectionMrdImpcFailureActionCreator(e));
  }
}

function* adminWatcher() {
  yield takeEvery(FETCH_ADMIN_DATA_REQUEST, fetchAdminData);
  yield takeEvery(FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST, fetchAdminReportCategoryData);
  yield takeEvery(EDIT_ADMIN_REPORT_DATA_REQUEST, editAdminReport);
  yield takeEvery(SAVE_CATEGORY_ADMIN_REQUEST, saveCategory);
  yield takeEvery(EDIT_CATEGORY_ADMIN_REQUEST, editCategory);
  yield takeEvery(DELETE_CATEGORY_ADMIN_REQUEST, deleteCategory);
  yield takeEvery(UPLOAD_USER_GUIDE_REQUEST, uploadUserGuide);
  yield takeEvery(DOWNLOAD_USER_GUIDE_REQUEST, downloadUserGuide);
  yield takeEvery(SAVE_GLOBAL_SELECTION_IMPC_REQUEST, saveGlobalSelectionImpc);
  yield takeEvery(DELETE_GLOBAL_SELECTION_IMPC_REQUEST, deleteGlobalSelectionImpc);
  yield takeEvery(SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST, saveGlobalSelectionOperator);
  yield takeEvery(DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST, deleteGlobalSelectionOperator);
  yield takeEvery(SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST, saveGlobalSelectionUnlocode);
  yield takeEvery(DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST, deleteGlobalSelectionUnlocode);
  yield takeEvery(SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST, saveGlobalSelectionMailbox);
  yield takeEvery(DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST, deleteGlobalSelectionMailbox);
  yield takeEvery(SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST, saveGlobalSelectionProduct);
  yield takeEvery(DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST, deleteGlobalSelectionProduct);
  yield takeEvery(SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST, saveGlobalSelectionMrdImpc);
  yield takeEvery(DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST, deleteGlobalSelectionMrdImpc);
}

export default adminWatcher;
